import React from "react";

/**
 * @TODO define type
 */
const experimentsAndSwitches = {} as any;
const experimentsAndSwitchesContext = React.createContext({
    ...experimentsAndSwitches
});

const { Provider }  = experimentsAndSwitchesContext;

export const ExperimentAndSwitchContextProvider = Provider;
export const ExperimentAndSwitchContext = experimentsAndSwitchesContext;